<template>
    <confirm-default
            :msg="msg"
            :visible="visible"
            @close="onClose"
            @confirm="onConfirm"
    >
        <p class="text-center">{{msg}}</p>
    </confirm-default>
</template>

<script>
    import ConfirmDefault  from './ConfirmDefault.vue'
    export default {
        name: 'ConfirmDeleteMenuItem',
        emits: ['close_delete_menu_item', 'confirm_delete_menu_item'],
        components:{
            'confirm-default' : ConfirmDefault
        },
        props: {
            visible: false,
            msg: {
                type: String,
                default: '¿Confirmar el borrado del elemento de menú?'
            },
        },
        methods : {
            onClose () {
                this.$emit('close_delete_menu_item', true);
            },
            onConfirm () {
                this.$emit('confirm_delete_menu_item', true);
            }
        }
    }
</script>
